import { FC, RefObject } from 'react';

import classNames from 'classnames';
import { NUMBER_SIGN } from 'utils/constants/common';

import { ActivatorElementType } from '@hh.ru/magritte-internal-drop-base';
import { HSpacing, Link, Text, useBreakpoint } from '@hh.ru/magritte-ui';
import { UserCircleOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import { HeaderUserDrop } from 'components/Header/HeaderUserDrop/HeaderUserDrop';

import { useSelector } from 'store/utils';

import styles from 'components/Header/HeaderUser/HeaderUser.module.less';

interface HeaderUserProps {
    dropActivatorRef: RefObject<ActivatorElementType>;
    isDropVisible: boolean;
    setIsDropVisibleOn: () => void;
    setIsDropVisibleOff: () => void;
}

export const HeaderUser: FC<HeaderUserProps> = ({
    dropActivatorRef,
    isDropVisible,
    setIsDropVisibleOn,
    setIsDropVisibleOff,
}) => {
    const employerId = useSelector(({ user }) => user.user?.employerId);

    const { isMobile } = useBreakpoint();

    return (
        <>
            {isMobile ? (
                <div className={styles.colorOverride}>
                    <UserCircleOutlinedSize24
                        initialColor="contrast-secondary"
                        onClick={setIsDropVisibleOn}
                        data-qa="header-user-button"
                    />
                </div>
            ) : (
                <Link Element="button" onClick={setIsDropVisibleOn} data-qa="header-user-button">
                    <div className={classNames(styles.wrapper, styles.colorOverride)}>
                        <UserCircleOutlinedSize24 initialColor="contrast-secondary" />
                        {employerId && (
                            <>
                                <HSpacing default={8} />
                                <Text typography="label-2-regular">
                                    {NUMBER_SIGN}
                                    {String(employerId)}
                                </Text>
                            </>
                        )}
                    </div>
                </Link>
            )}
            <HeaderUserDrop
                dropActivatorRef={dropActivatorRef}
                isDropVisible={isDropVisible}
                setIsDropVisibleOff={setIsDropVisibleOff}
            />
        </>
    );
};
